// Doctor names must match the existing doctors collection and booking payloads.
export const normalizeCertificateDoctor = (doctor) => {
  const name = String(doctor || "").replace(/\s/g, "").toLowerCase();
  return name === "i.natcha" ? "i.nutcha" : name;
};

const DOCTOR_CODES = {
  "l.somprasong": "SPL",
  "s.jindapa": "JDS",
  "c.vatcharee": "VCR",
  "p.sirincha": "SRP",
  "i.nutcha": "NCI",
};

export const LPH_BOOKING_CERT_TEMPLATES = {
  "l.somprasong": "LPH_medical_cert_SPL.docx",
  "s.jindapa": "LPH_medical_cert_JDS.docx",
  "c.vatcharee": "LPH_medical_cert_VCC.docx",
  "p.sirincha": "LPH_medical_cert_SRP.docx",
  "i.nutcha": "LPH_medical_cert_NCI.docx",
};

export const LPH_ANNUAL_MASK_CERT_TEMPLATES = {
  "c.vatcharee": "LPH_AnnualMask_VCR.docx",
  "s.jindapa": "LPH_AnnualMask_JDS.docx",
  "p.sirincha": "LPH_AnnualMask_SRP.docx",
  "i.nutcha": "LPH_AnnualMask_NCI.docx",
};

const getLPHExportTemplatePath = (doctor, type, language) => {
  const code = DOCTOR_CODES[normalizeCertificateDoctor(doctor)];
  if (!code) throw new Error("No LPH medical certificate template is configured for this doctor.");
  const embedded = ["SRP", "NCI"].includes(code);
  const english = type === "medical_cert" && language === "en" && !embedded ? "_EN" : "";
  return `templates/${embedded ? "medical_cert_embedded" : "medical_cert"}/LPH_${type}_${code}${english}.docx`;
};

export const getLPHWorkLeaveTemplatePath = (doctor) =>
  getLPHExportTemplatePath(doctor, "WorkLeave");

export const getLPHCPAPTemplatePath = (doctor, language = "th") =>
  getLPHExportTemplatePath(doctor, "medical_cert", String(language || "th").toLowerCase());
